import { NgModule } from '@angular/core';
import { MediaViewerService } from './media-viewer.service';
import { MediaViewerComponent } from './media-viewer.component';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiSwipeModule } from '@fi-shared/fi-directives/fi-swipe/fi-swipe.module';
import { MediaViewerVimeoComponent } from './media-viewer-vimeo/media-viewer-vimeo.component';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        FiSwipeModule,
        FiVimeoModule,
        FiLoadingModule,
    ],
    declarations: [MediaViewerComponent, MediaViewerVimeoComponent],
    providers: [MediaViewerService],
    exports: [],
})
export class FiMediaViewerModule {}
